import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-pie-chart',
	templateUrl:'./WaPieChartProPage.html',
	styles: [],
	styleUrls:['./WaPieChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPieChartProPage
{
	mdContent_417 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaPieChart;
\`\`\``;
	mdContent_418 = `\`\`\`java
new WaPieChart<>()
\`\`\``;
	mdContent_419 = `\`\`\`java
var chart = new WaPieChart<>();
chart.setLabel("Market Share");
chart.setLegendPosition(LegendPosition.Right);
\`\`\``;
}
